import InputField from 'components/fields/InputField';
import { useState } from 'react';
import axios from 'axios';
import { CONFIG } from 'variables/config';
import { GoogleLogin } from '@react-oauth/google';

function SignUpSeller() {
    const [error, setError] = useState('');
    const [newUser, setNewUser] = useState({
        name: '',
        surname: '',
        email: '',
        password: '',
        siret: '00000000000000',
        phone: '',
        company: 'leadrs.co',
        referal: '',
        accept_tos: true,
        confirmPassword: '',
        type: 'seller',
        role: 'ceo',
        business: 'freelance',
        industry: 'Rénovation',
        channels: ['google'],
        leadsPerWeek: 100,
    });

    const loginGoogle = (token: string) => {
        axios
            .post(`${CONFIG.apiUrl}/auth/google`, { ...newUser, token })
            .then((response: any) => {
                if (response.data.token) {
                    localStorage.setItem('token', response.data.token);
                    localStorage.setItem('user-type', response.data.type);
                    window.location.href = '/admin/dashboard';
                }
            })
            .catch((error: any) => {
                console.log(error);
                setError('Erreur lors de la connexion avec Google');
            });
    };

    const handleChange = (e: any) => {
        const { id, value } = e.target;

        if (id === 'channels') {
            setNewUser((prev) => ({ ...prev, [id]: [value] }));
            return;
        }

        if (id === 'accept_tos') {
            setNewUser((prev) => ({ ...prev, [id]: !prev.accept_tos }));
            return;
        }

        setNewUser((prev) => ({ ...prev, [id]: value }));
        setError('');
    };

    const handleSubmit = (e: any) => {
        e.preventDefault();
        if (newUser.password !== newUser.confirmPassword) return;
        const submitData = { ...newUser };
        delete submitData.confirmPassword;

        axios
            .post(`${CONFIG.apiUrl}/auth/register`, submitData)
            .then((res) => {
                localStorage.setItem('token', res.data.token);
                localStorage.setItem('user-type', newUser.type);
                if (res.data.token.length > 10) {
                    window.location.href = '/admin/dashboard';
                }
            })
            .catch((err) => setError(err.response.data.error));
    };

    return (
        <div className="flex h-full min-h-screen w-full items-center justify-center" style={{ backgroundColor: '#e8e7fb' }}>
            <div className="relative w-full max-w-xl">
                <div className="mt-3 absolute -top-8 left-1/2 z-10 flex h-16 w-16 -translate-x-1/2 items-center justify-center rounded-full shadow-lg">
                    <img src="/assets/simple-logo.png" alt="Leadrs" className="h-16 w-16" />
                </div>
                <div className="rounded-3xl bg-white px-10 pb-10 pt-16 shadow-md">
                    <h3 className="text-center text-2xl font-bold text-navy-700 dark:text-white">
                        Rejoindre Leadrs !
                    </h3>
                    <p className="mt-2 text-center text-base text-gray-600">
                        Vendez facilement vos leads.
                    </p>
                {error && (
                    <p className="mt-2 text-center text-base text-red-500">
                        {error}
                    </p>
                )}
                {newUser.password !== newUser.confirmPassword && (
                    <p className="mt-2 text-center text-base text-red-500">
                        Les mots de passes ne correspondent pas
                    </p>
                )}

                <form className="mt-6" onSubmit={handleSubmit}>
                    <p className="mb-4 text-left text-base font-semibold text-gray-900">
                        Informations de votre activité
                    </p>
                    <div className="grid w-full grid-cols-1 gap-4 md:grid-cols-2">
                        <InputField
                            variant="auth"
                            extra=""
                            label="Prénom*"
                            placeholder="Jeff"
                            id="name"
                            type="text"
                            onChange={handleChange}
                        />
                        <InputField
                            variant="auth"
                            extra=""
                            label="Nom*"
                            placeholder="Bezos"
                            id="surname"
                            type="text"
                            onChange={handleChange}
                        />
                        <InputField
                            variant="auth"
                            extra=""
                            label="Email*"
                            placeholder="vous@exemple.com"
                            id="email"
                            type="text"
                            onChange={handleChange}
                        />
                        <InputField
                            variant="auth"
                            extra=""
                            label="Téléphone*"
                            placeholder="+33 6 12 34 56 78"
                            id="phone"
                            type="text"
                            onChange={handleChange}
                        />
                        <div className="relative">
                            <InputField
                                variant="auth"
                                extra=""
                                label="Mot de passe*"
                                placeholder="********"
                                id="password"
                                type="password"
                                onChange={handleChange}
                            />
                            <p className="ml-1 mt-1 text-xs text-gray-500">
                                🔒 Minimum 8 caractères
                            </p>
                        </div>
                        <InputField
                            variant="auth"
                            extra=""
                            label="Confirmer mot de passe*"
                            placeholder="********"
                            id="confirmPassword"
                            type="password"
                            onChange={handleChange}
                        />
                        <div className="col-span-1 md:col-span-2">
                            <InputField
                                variant="auth"
                                extra=""
                                label="Code de parrainage (facultatif)"
                                placeholder="DF5a3e8RT"
                                id="referal"
                                type="text"
                                onChange={handleChange}
                            />
                            <p className="ml-1 mt-1 text-xs text-orange-500">
                                🔥 Si vous avez un code de parrainage, saisissez-le ici
                            </p>
                        </div>
                    </div>


                    <button
                        type="submit"
                        className="mt-6 w-full rounded-xl bg-[#7166fe] py-3 text-base font-semibold text-white hover:bg-[#5c50f2]"
                    >
                        S'inscrire
                    </button>
                </form>

                <div className="mt-5 flex items-center justify-center">
                    <div className="w-full border-t border-gray-300"></div>
                    <span className="mx-2 text-sm text-gray-500">
                        OU
                    </span>
                    <div className="w-full border-t border-gray-300"></div>
                </div>

                <div className="mt-4 flex w-full justify-center">
                    <GoogleLogin
                        onSuccess={(credentialResponse: any) => {
                            loginGoogle(credentialResponse.credential);
                        }}
                        containerProps={{
                            className: 'w-full',
                        }}
                        shape="circle"
                        size="large"
                        theme="outline"
                        logo_alignment="center"
                        onError={() => {
                            console.log('Login Failed');
                            setError('Échec de la connexion avec Google');
                        }}
                    />
                </div>
                </div>
            </div>
        </div>
    );
}

export default SignUpSeller;
